module.exports = __webpack_public_path__ + "img/icon-time.b9cb5f9f.svg";